{
  "version": 1,
  "asset_id": "94409e00-ba9e-48fc-aa94-25634d5008cb",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/94409e00-ba9e-48fc-aa94-25634d5008cb/author-robert-bemelmans.jpg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/94409e00-ba9e-48fc-aa94-25634d5008cb/author-robert-bemelmans.jpg",
  "original_filename": "author-robert-bemelmans.jpg",
  "size": 241762,
  "content_type": "image/jpeg",
  "created_at": "2026-08-30T14:14:57Z"
}
